import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  actions as creditDemandActions,
  selectors as CreditDemandeSelectors,
} from "redux/slices/v2/DemandeUnCredit";
import Provinces from "../../../../assets/Provinces.json";
import style from "./firstStep.module.css";
import useTranslation from "next-translate/useTranslation";

function FirstStep(props: any) {
  const { t, lang } = useTranslation("creditImmo");
  const activeStep = useSelector(CreditDemandeSelectors.activeStepSelector);
  const data = useSelector(CreditDemandeSelectors.selectDemandUnCredit);

  const [checkedItems, setCheckedItems] = useState({ [data.etatdAchat]: true });
  const [etatdAchat, setEtatdAchat] = useState(data.etatdAchat);
  const [quandAcheter, setQuandAchat] = useState(data.quandAcheter);
  const [ville, setVille] = useState({ ville: data.ville, villeError: false });

  const handleChange = (event, item) => {
    //
    setEtatdAchat(item);
    setCheckedItems({ [event.target.name]: true });
  };
  //
  const [checkedAchatTimeItems, setCheckedAchatTimeItems] = useState({
    [data.quandAcheter]: true,
  });

  const handleAchatTimeChange = (event, item) => {
    //
    //
    setQuandAchat(item);
    setCheckedAchatTimeItems({ [event.target.name]: true });
  };

  //
  const dispatch = useDispatch();

  const setNextStep = (step) => {
    dispatch(
      creditDemandActions.setFirstFormAnswers({
        activeStep: step,
        etatdAchat: etatdAchat,
        quandAcheter: quandAcheter,
        ville: ville.ville,
      })
    );
    // dispatch(creditDemandActions.setActivesTep(step));
  };
  const setPreviousStep = (step) => {
    dispatch(creditDemandActions.setActivesTep(step));
  };

  useEffect(() => {}, [activeStep]);
  const message =
    "Bonjour, j'aimerai me faire accompagner dans ma demande de crédit immobilier";
  const phoneNumber = "+212669793808";
  const linkToWhatsapp = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;

  return (
    <div className={style.leftSideContent}>
      <div className={style.whatsapp}>
        <a href={linkToWhatsapp} target="_blank">
          <svg
            width="29"
            height="29"
            viewBox="0 0 29 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.2749 16.742C20.9212 16.5565 19.2102 15.6533 18.8976 15.5162C18.5851 15.3791 18.3383 15.3226 18.0915 15.6613C17.8447 16 17.1291 16.7581 16.9152 16.9839C16.7014 17.2097 16.4957 17.2258 16.142 17.0404C15.7883 16.8549 14.6614 16.4436 13.3535 15.2017C12.3335 14.242 11.6672 13.0726 11.4698 12.7178C11.2723 12.3629 11.4698 12.1775 11.6507 12.0081C11.8317 11.8388 12.0209 11.6129 12.2101 11.4113C12.3993 11.2097 12.4569 11.0726 12.5885 10.8388C12.7201 10.6049 12.6625 10.4033 12.5885 10.2259C12.5144 10.0484 11.8646 8.31456 11.5931 7.59682C11.3217 6.87908 11.0256 6.99198 10.8117 6.98392C10.5978 6.97586 10.3675 6.93553 10.129 6.93553C9.76702 6.93553 9.41331 7.07263 9.16654 7.33876C8.82928 7.6694 7.87509 8.48392 7.80928 10.1936C7.74347 11.9033 8.94444 13.621 9.11718 13.8629C9.28992 14.1049 11.4286 17.8145 14.9822 19.3387C18.5357 20.8629 18.5604 20.4033 19.2102 20.3629C19.8601 20.3226 21.3407 19.5968 21.6697 18.7984C21.9988 18 22.0235 17.2984 21.9412 17.1533C21.8589 17.0081 21.6204 16.9113 21.2749 16.7178V16.742ZM14.7518 25.0081C12.4898 25.0081 10.2688 24.3549 8.38508 23.1291L3.93493 24.5242L5.38267 20.3065C3.94316 18.371 3.16993 16.0404 3.17816 13.6452C3.17816 7.37908 8.36863 2.29038 14.7601 2.29038C21.1515 2.29038 26.342 7.37908 26.342 13.6452C26.342 19.9113 21.1433 25 14.7601 25L14.7518 25.0081ZM14.7518 0.0161896C7.06896 0.0161896 0.84203 6.12102 0.84203 13.6533C0.84203 16.1371 1.52477 18.5726 2.8409 20.6936L0.332031 28.0081L8.03137 25.5887C10.0878 26.7016 12.4075 27.2903 14.7518 27.2903C22.4347 27.2903 28.6617 21.1855 28.6617 13.6533C28.6617 6.12102 22.4347 0.0161896 14.7518 0.0161896Z"
              fill="white"
            />
          </svg>
        </a>
      </div>
      <div className={`${style.questMob}`}>
        {props?.titre && <h1 className={style.title}>{props?.titre}</h1>}
        {props?.subTitle && <p className={style.subtitle}>{props?.subTitle}</p>}
      </div>
      <div className={style.leftSideContentEstima}>
        {props?.choices?.length > 0 &&
          props.choices.map((e, index) => (
            <>
              <label
                key={index}
                htmlFor={`${e[props.lang]}`}
                className={classNames(
                  style.itemSelect,
                  checkedItems[e[props.lang]] ? style.itemChecked : ""
                )}
              >
                <span className={style.mobileIcon}>{e[props.lang]}</span>
                <div
                  className={`${style.circle} ${
                    checkedItems[e[props.lang]] ? style.circleCheck : ""
                  }`}
                >
                  <span
                    className={`${style.subCircle} ${
                      checkedItems[e[props.lang]] ? style.subCircleCheck : ""
                    }`}
                  ></span>
                </div>
                <input
                  type="checkbox"
                  name={`${e[props.lang]}`}
                  id={`${e[props.lang]}`}
                  defaultChecked={checkedItems[e[props.lang]]}
                  onChange={(event) => {
                    handleChange(event, e[props.lang]);
                  }}
                  style={{ display: "none" }}
                />
              </label>
            </>
          ))}
      </div>

      {etatdAchat != "" &&
      etatdAchat != "J'ai signé un contrat de réservation" ? (
        <>
          <div className={`${style.questMob}`}>
            <h1 className={style.title}>{props.Title2}</h1>
          </div>
          <div className={style.leftSideContentEstima}>
            {props?.choices2?.length > 0 &&
              props.choices2.map((e, index) => (
                <>
                  <label
                    key={index}
                    htmlFor={`${e[props.lang]}`}
                    className={classNames(
                      style.itemSelect,
                      checkedAchatTimeItems[e[props.lang]]
                        ? style.itemChecked
                        : ""
                    )}
                  >
                    <span className={style.mobileIcon}>{e[props.lang]}</span>
                    <div
                      className={`${style.circle} ${
                        checkedAchatTimeItems[e[props.lang]]
                          ? style.circleCheck
                          : ""
                      }`}
                    >
                      <span
                        className={`${style.subCircle} ${
                          checkedAchatTimeItems[e[props.lang]]
                            ? style.subCircleCheck
                            : ""
                        }`}
                      ></span>
                    </div>
                    <input
                      type="checkbox"
                      name={`${e[props.lang]}`}
                      id={`${e[props.lang]}`}
                      defaultChecked={checkedAchatTimeItems[e[props.lang]]}
                      onChange={(event) => {
                        handleAchatTimeChange(event, e[props.lang]);
                      }}
                      style={{ display: "none" }}
                    />
                  </label>
                </>
              ))}
          </div>
        </>
      ) : null}
      {quandAcheter != "" ||
      etatdAchat == "J'ai signé un contrat de réservation" ? (
        <>
          <div className={`${style.questMob}`}>
            <p className={style.title}>{props.title3}</p>
          </div>
          <div
            className={style.leftSideContentEstima}
            style={{ paddingBottom: 150 }}
          >
            {/* <input
              autoComplete="off"
              list="provinces-choices"
              value={t(ville.ville)}
              placeholder={t("Choisir la ville")}
              className={style.ville_credit_input}
              onBlur={(e) => {
                
                if (
                  !Provinces.filter((item) => {
                    return item.name == e.target.value;
                  }).length
                ) {
                  setVille({ ville: "", villeError: false });
                }
              }}
              onChange={(choice) => {
                
                setVille({
                  ville: choice.target.value,
                  villeError:
                    Provinces.filter((item) => {
                      return props.t(item.name) == choice.target.value;
                    }).length === 0,
                });
              }}
            />
            <datalist id="provinces-choices">
              {Provinces.sort((a, b) => a.name.localeCompare(b.name)).map(
                function (item) {
                  return <option value={item["name"]}>{t(item["name"])}</option>;
                }
              )}
            </datalist> */}
            <div className={style.dropdownCon}>
              <select
                className={style.ville_credit_input}
                style={{
                  border: "1px solid #dddddd",
                  color: ville.ville == "" ? "#7b7b7b" : "black",
                }}
                placeholder={t("Choisir la ville")}
                onChange={(choice) => {
                  setVille({
                    ville: choice.target.value,
                    villeError:
                      Provinces.filter((item) => {
                        return props.t(item.name) == choice.target.value;
                      }).length === 0,
                  });
                }}
              >
                <option disabled selected value={null}>
                  {t("-- Choisir la ville --")}
                </option>
                {Provinces.sort((a, b) => a.name.localeCompare(b.name)).map(
                  function (item) {
                    return (
                      <option value={item["name"]}>{t(item["name"])}</option>
                    );
                  }
                )}
              </select>
              <span className={style.dropdownIcon}>
                <svg
                  width="22"
                  height="20"
                  viewBox="0 0 22 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.435 4.42869C10.7473 4.0816 11.2546 4.0816 11.567 4.42869L14.7657 7.98286C14.9956 8.23831 15.063 8.61872 14.9381 8.95192C14.8131 9.28513 14.5233 9.50171 14.1984 9.50171L7.80106 9.49893C7.47869 9.49893 7.18631 9.28235 7.06137 8.94915C6.93642 8.61594 7.00639 8.23554 7.23379 7.98008L10.4325 4.42591L10.435 4.42869Z"
                    fill="black"
                    fill-opacity="0.8"
                  />
                  <path
                    d="M10.435 15.5716C10.7473 15.9184 11.2546 15.9184 11.567 15.5716L14.7657 12.0196C14.9956 11.7643 15.063 11.3841 14.9381 11.0512C14.8131 10.7182 14.5233 10.5017 14.1984 10.5017L7.80106 10.5045C7.47869 10.5045 7.18631 10.7209 7.06137 11.0539C6.93642 11.3869 7.00639 11.7671 7.23379 12.0224L10.4325 15.5743L10.435 15.5716Z"
                    fill="black"
                    fill-opacity="0.8"
                  />
                </svg>
              </span>
            </div>
          </div>
        </>
      ) : null}

      <div className={style.btnContainer}>
        <button
          className={ville.ville == "" ? style.btnUnValider : style.btnValider}
          disabled={ville.ville == ""}
          onClick={() => {
            setNextStep(2);
          }}
        >
          {props.Button_text}
        </button>
      </div>
    </div>
  );
}

export default FirstStep;
